import { useRemoveM2MLinksMutation } from "generated/graphql"
import { snakeCase, startCase } from "lodash-es"
import AppToaster from "utils/AppToaster"
import useDCStore from "./dc.store"

type RemoveLinkOptions = {
  fieldName: string
  fieldIds: string[]
  displayName?: string
  modelName?: string
  modelId?: string
  statePath?: string
  itemIndex?: number
}
const useDCRemoveM2M = () => {
  const dcId = useDCStore(store => store.state.basicDetails.id)
  const [mutate, { loading }] = useRemoveM2MLinksMutation()

  /**
   *
   * @param fieldName field name to delete (automatically converts to snake case) fieldName -> field_name
   * @param fieldIds ids of the field to delete
   */
  function removeLink(options: RemoveLinkOptions) {
    const {
      fieldName,
      fieldIds,
      displayName,
      modelName = "vt_ecommerce.DistributionCentre",
      modelId,
    } = options
    if (fieldIds.some(id => !parseInt(id))) return null
    mutate({
      variables: {
        model: modelName,
        modelId: modelId ?? dcId,
        field: snakeCase(fieldName),
        fieldIds,
      },
      onCompleted() {
        AppToaster.show({
          intent: "success",
          message: `${
            displayName || startCase(fieldName)
          } removed successfully!`,
        })
      },
    })
  }
  return { loading, removeLink }
}

export default useDCRemoveM2M
